import { ExchangeCode } from "@/lib/market-data/market-data.types";

/**
 * Exchanges whose public REST/WS endpoints send CORS headers that allow
 * browser requests from our app origin.
 *
 * Verified via GET with Origin: https://app.trigger.fun
 * - binance, asterdex, gate, hyperliquid: access-control-allow-origin: *
 * - bybit: access-control-allow-origin: https://app.trigger.fun
 *
 * Blocked in the browser (no Access-Control-Allow-Origin):
 * - kucoin — fetched by our API and forwarded to the miniapp
 */
export const BROWSER_DIRECT_CANDLE_EXCHANGES: ExchangeCode[] = [
  "binance",
  "bybit",
  "hyperliquid",
  "asterdex",
  "gate",
];

export function supportsBrowserDirectCandleRest(
  exchange: ExchangeCode
): boolean {
  return BROWSER_DIRECT_CANDLE_EXCHANGES.includes(exchange);
}

export function supportsBrowserDirectCandleWs(
  exchange: ExchangeCode
): boolean {
  return supportsBrowserDirectCandleRest(exchange);
}

export function requiresApiCandleFallback(exchange: ExchangeCode): boolean {
  return !supportsBrowserDirectCandleRest(exchange);
}
